import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useCreateUser } from '../Providers/CreateUserProvider/CreateUserContext';

const ContactDetailForm: React.FC = () => {
  const { createUserData, setCreateUserData } = useCreateUser();

  const formik = useFormik({
    enableReinitialize: true, // allows Formik to reinit when context changes
    initialValues: {
      address: createUserData.address || '',
      street: createUserData.street || '',
      city: createUserData.city || '',
      state: createUserData.state || '',
      country: createUserData.country || '',
    },
    validationSchema: Yup.object({
      address: Yup.string().required('Address is required'),
      street: Yup.string().required('Street is required'),
      city: Yup.string().required('City is required'),
      state: Yup.string().required('State is required'),
      country: Yup.string().required('Country is required'),
    }),
    onSubmit: () => {}, // handled by parent stepper
  });

  // 👇 Sync formik values into context whenever they change
  useEffect(() => {
    setCreateUserData((prev) => ({
      ...prev,
      ...formik.values,
    }));
  }, [formik.values, setCreateUserData]);

  return (
    <div className="max-w-5xl mx-auto p-6 space-y-6 bg-white rounded-lg">
      {/* Address */}
      <div>
        <label className="block text-sm font-semibold text-gray-800 mb-2">Address</label>
        <textarea
          name="address"
          value={formik.values.address}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Enter Address"
          className="w-full h-28 rounded-md border border-gray-300 bg-[#f7fbfd] px-4 py-2 text-gray-800 placeholder-gray-400 focus:outline-none focus:outline-none focus:ring-0 focus:border-gray-300"
        />
        {formik.touched.address && formik.errors.address && <p className="text-red-500 text-sm mt-1">{formik.errors.address}</p>}
      </div>

      {/* Street + City */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-semibold text-gray-800 mb-2">Street</label>
          <input
            type="text"
            name="street"
            value={formik.values.street}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Enter street"
            className="w-full rounded-md border border-gray-300 bg-[#f7fbfd] px-4 py-2 text-gray-800 placeholder-gray-400 focus:outline-none focus:outline-none focus:ring-0 focus:border-gray-300"
          />
          {formik.touched.street && formik.errors.street && <p className="text-red-500 text-sm mt-1">{formik.errors.street}</p>}
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-800 mb-2">City</label>
          <input
            type="text"
            name="city"
            value={formik.values.city}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Enter city"
            className="w-full rounded-md border border-gray-300 bg-[#f7fbfd] px-4 py-2 text-gray-800 placeholder-gray-400 focus:outline-none focus:outline-none focus:ring-0 focus:border-gray-300"
          />
          {formik.touched.city && formik.errors.city && <p className="text-red-500 text-sm mt-1">{formik.errors.city}</p>}
        </div>
      </div>

      {/* State + Country */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-semibold text-gray-800 mb-2">State</label>
          <input
            type="text"
            name="state"
            value={formik.values.state}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Enter state"
            className="w-full rounded-md border border-gray-300 bg-[#f7fbfd] px-4 py-2 text-gray-800 placeholder-gray-400 focus:outline-none focus:outline-none focus:ring-0 focus:border-gray-300"
          />
          {formik.touched.state && formik.errors.state && <p className="text-red-500 text-sm mt-1">{formik.errors.state}</p>}
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-800 mb-2">Country</label>
          <input
            type="text"
            name="country"
            value={formik.values.country}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Enter country"
            className="w-full rounded-md border border-gray-300 bg-[#f7fbfd] px-4 py-2 text-gray-800 placeholder-gray-400 focus:outline-none focus:outline-none focus:ring-0 focus:border-gray-300"
          />
          {formik.touched.country && formik.errors.country && <p className="text-red-500 text-sm mt-1">{formik.errors.country}</p>}
        </div>
      </div>
    </div>
  );
};

export default ContactDetailForm;
